import current from './current';

export default {
	current
};
